import React, { useState, useRef } from "react";

import Cat from "./Cat";
import { downloadAsJpg, downloadAsSvg } from "./Cat/utils/download";

const Generator = ({ schema, action }) => {
  const [borderRound, setBorderRound] = useState(true);
  const [canGenerate, setCanGenerate] = useState(true);
  const catRef = useRef(null);
  const generatorClass = borderRound ? "rounded-full" : "rounded-2xl";

  const actionWrapper = () => {
    action();
    setCanGenerate(false);
    setTimeout(() => {
      setCanGenerate(true);
    }, 1000);
  };

  return (
    <div className="m-auto md:m-0 text-center">
      <div className="inline-block mb-2 mx-auto">
        <button
          onClick={() => setBorderRound(true)}
          className={`py-1 px-2 rounded-none rounded-l-full focus:outline-none ${
            borderRound ? "bg-green-500" : "bg-gray-100 dark:bg-gray-800"
          }`}
        >
          <div
            className={`w-5 h-5 border-2 rounded-full ${
              borderRound ? "border-white" : "border-green-500"
            }`}
          />
        </button>
        <button
          onClick={() => setBorderRound(false)}
          className={`py-1 px-2 rounded-none rounded-r-full focus:outline-none ${
            !borderRound ? "bg-green-500" : "bg-gray-100 dark:bg-gray-800"
          }`}
        >
          <div
            className={`w-5 h-5 border-2 rounded ${
              !borderRound ? "border-white" : "border-green-500"
            }`}
          />
        </button>
      </div>
      <div
        ref={catRef}
        className={`w-60 h-60 border-8 border-gray-300 dark:border-gray-600 overflow-hidden ${generatorClass}`}
      >
        <Cat schema={schema} />
      </div>
      <div className="my-5">
        <div className="text-center pb-5">
          <button
            className="px-5 py-3 bg-green-500 hover:bg-green-400 rounded-full text-white text-xl focus:outline-none appearance-none disabled:opacity-50"
            style={{ transition: "200ms opacity" }}
            disabled={!canGenerate}
            onClick={() => actionWrapper()}
          >
            Generate
          </button>
        </div>
        <div className="text-center pt-5">
          <span className="mr-2">Download as</span>
          <button
            onClick={() => downloadAsSvg(catRef.current)}
            className="px-2 mr-2 bg-green-500 hover:bg-green-400 rounded-full text-white focus:outline-none"
          >
            svg
          </button>
          <span className="mr-2">or</span>
          <button
            onClick={() => downloadAsJpg(catRef.current)}
            className="px-2 mr-2 bg-green-500 hover:bg-green-400 rounded-full text-white focus:outline-none"
          >
            jpg
          </button>
        </div>
      </div>
    </div>
  );
};

export default Generator;
